export class StampingPreviewCanvas {
  constructor(dom) {
    this.dom = dom;
    this.dpr = window.devicePixelRatio || 1;
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.ctx.scale(this.dpr, this.dpr);
    this.dom.append(this.canvas);
    window.addEventListener("resize", () => this.resize());
  }

  init() {
    this.resize();
  }

  attachStampingPreview(previewInstance) {
    this.stampingPreview = previewInstance;
    this.draw();
  }

  draw() {
    this.ctx.clearRect(0, 0, this.width, this.height);
    this.ctx.fillStyle = "#DDDDDD";
    this.ctx.fillRect(0, 0, this.width, this.height);
    this.stampingPreview.draw();
  }

  getSettings() {
    return this.settings;
  }

  resize() {
    let domRect = this.dom.getBoundingClientRect();
    this.scale = 1;
    this.canvas.width = domRect.width * this.dpr;
    this.canvas.height = domRect.height * this.dpr;
    this.canvas.style.width = domRect.width + "px";
    this.canvas.style.height = domRect.height + "px";
    this.width = domRect.width * this.dpr;
    this.height = domRect.height * this.dpr;

    let embossLimit = document
      .querySelector("#page-simple-product")
      .getAttribute("data-emboss-limit");
    embossLimit = parseInt(embossLimit);

    if (isNaN(embossLimit)) {
      embossLimit = 10;
    }

    const parentDOM = document.querySelector("#customisation-stamping");
    const embossLimitString = parentDOM.querySelector("#emboss-limit");
    embossLimitString.textContent = embossLimit;

    this.settings = {
      posX: [this.canvas.width / 2 / this.dpr],
      posY: [this.canvas.height / 2 / this.dpr],
      alignment: "center",
      size: this.canvas.height / 2 / this.dpr,
      limit: embossLimit,
    };

    if (this.stampingPreview) {
      clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(() => {
        this.draw();
      }, 500);
    }
  }
}
